import { message } from "antd";
import { TOKEN } from "../config/localstorage_keys";
import { getApiErrorMessage } from "../utils/apiErrorUtils";

/**
 * Shared axios response error handler — always rejects so callers can catch.
 * Shows a toast for recoverable failures (not 401 session expiry).
 */
export const handleApiResponseError = (error) => {
  if (error?.code === "ERR_CANCELED") {
    return Promise.reject(error);
  }

  if (error?.response?.status === 401) {
    message.error("Session expired. Redirecting to login...");
    localStorage.removeItem(TOKEN);
    setTimeout(() => {
      window.location.replace("/login");
    }, 1000);
    return Promise.reject(error);
  }

  const config = error?.config || {};
  if (!config.skipErrorToast) {
    const msg = getApiErrorMessage(error);
    if (msg) {
      message.error(msg);
    }
  }

  return Promise.reject(error);
};

export const attachApiErrorHandling = (axiosInstance) => {
  axiosInstance.interceptors.response.use(
    (res) => res,
    handleApiResponseError
  );
};
